var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        {
          show: _vm.getIsOpenFirstStepDeleteAccountModal,
          "d-block": _vm.getIsOpenFirstStepDeleteAccountModal,
        },
      ],
      staticStyle: { display: "block" },
      attrs: {
        id: "go-modal-accountDelete-step1",
        "aria-hidden": "true",
        tabindex: "-1",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-prompt" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(_vm.$t("myPage.profile.firstStepDeletePopup.title"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCloseModal.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("P", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "myPage.profile.firstStepDeletePopup.description.firstText"
                    )
                  )
                ),
                _c("br"),
                _c("span", { staticClass: "go-user-name" }, [
                  _vm._v(_vm._s(_vm.tempUserName)),
                ]),
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "myPage.profile.firstStepDeletePopup.description.secondText"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.deleteReason,
                        expression: "deleteReason",
                      },
                    ],
                    staticClass: "go-form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.deleteReason = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      {
                        attrs: {
                          value: "1",
                          disabled: "",
                          selected: "",
                          hidden: "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "myPage.profile.firstStepDeletePopup.optionSelect.first"
                            )
                          )
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.firstStepDeletePopup.optionSelect.second"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "3" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.firstStepDeletePopup.optionSelect.third"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "4" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.firstStepDeletePopup.optionSelect.fourth"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "5" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.firstStepDeletePopup.optionSelect.fifth"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "6" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.firstStepDeletePopup.optionSelect.sixth"
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm.showRequiredMessage
                  ? _c(
                      "div",
                      { staticClass: "go-form-feedback-invalid text-left" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "myPage.profile.firstStepDeletePopup.requiredAnswer"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCloseModal.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "myPage.profile.firstStepDeletePopup.cancelButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleNextStep.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "myPage.profile.firstStepDeletePopup.nextButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }